import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

export const UPDATE_CURRENT_CONTRACT = 'UPDATE_CURRENT_CONTRACT';
export const CLEAN_CURRENT_CONTRACT = 'CLEAN_CURRENT_CONTRACT';
export const CLEAN_CURRENT_CONTRACT_DEBIT = 'CLEAN_CURRENT_CONTRACT_DEBIT';

const CREATE_SERVICE_CONTRACT = 'CREATE_SERVICE_CONTRACT';
export const CREATE_SERVICE_CONTRACT_API = buildApiTypeAction(CREATE_SERVICE_CONTRACT, ApiActionTypes.REQUEST)
export const CREATE_SERVICE_CONTRACT_API_SUCCESS = buildApiTypeAction(CREATE_SERVICE_CONTRACT, ApiActionTypes.SUCCESS)
export const CREATE_SERVICE_CONTRACT_API_ERROR = buildApiTypeAction(CREATE_SERVICE_CONTRACT, ApiActionTypes.ERROR)

const GET_SERVICE_CONTRACTS = 'GET_SERVICE_CONTRACTS';
export const GET_SERVICE_CONTRACTS_API = buildApiTypeAction(GET_SERVICE_CONTRACTS, ApiActionTypes.REQUEST)
export const GET_SERVICE_CONTRACTS_API_SUCCESS = buildApiTypeAction(GET_SERVICE_CONTRACTS, ApiActionTypes.SUCCESS)
export const GET_SERVICE_CONTRACTS_API_ERROR = buildApiTypeAction(GET_SERVICE_CONTRACTS, ApiActionTypes.ERROR)

const GET_CONTRACT_BY_ID = 'GET_CONTRACT_BY_ID';
export const GET_CONTRACT_BY_ID_API = buildApiTypeAction(GET_CONTRACT_BY_ID, ApiActionTypes.REQUEST)
export const GET_CONTRACT_BY_ID_API_SUCCESS = buildApiTypeAction(GET_CONTRACT_BY_ID, ApiActionTypes.SUCCESS)
export const GET_CONTRACT_BY_ID_API_ERROR = buildApiTypeAction(GET_CONTRACT_BY_ID, ApiActionTypes.ERROR)

const GET_SERVICE_CONTRACT_DEBITS = 'GET_SERVICE_CONTRACT_DEBITS';
export const GET_SERVICE_CONTRACT_DEBITS_API = buildApiTypeAction(GET_SERVICE_CONTRACT_DEBITS, ApiActionTypes.REQUEST)
export const GET_SERVICE_CONTRACT_DEBITS_API_SUCCESS = buildApiTypeAction(GET_SERVICE_CONTRACT_DEBITS, ApiActionTypes.SUCCESS)
export const GET_SERVICE_CONTRACT_DEBITS_API_ERROR = buildApiTypeAction(GET_SERVICE_CONTRACT_DEBITS, ApiActionTypes.ERROR)

const GET_CONTRACT_DEBIT_BY_ID = 'GET_CONTRACT_DEBIT_BY_ID';
export const GET_CONTRACT_DEBIT_BY_ID_API = buildApiTypeAction(GET_CONTRACT_DEBIT_BY_ID, ApiActionTypes.REQUEST)
export const GET_CONTRACT_DEBIT_BY_ID_API_SUCCESS = buildApiTypeAction(GET_CONTRACT_DEBIT_BY_ID, ApiActionTypes.SUCCESS)
export const GET_CONTRACT_DEBIT_BY_ID_API_ERROR = buildApiTypeAction(GET_CONTRACT_DEBIT_BY_ID, ApiActionTypes.ERROR)

const UPDATE_SERVICE_CONTRACT = 'UPDATE_SERVICE_CONTRACT';
export const UPDATE_SERVICE_CONTRACT_API = buildApiTypeAction(UPDATE_SERVICE_CONTRACT, ApiActionTypes.REQUEST)
export const UPDATE_SERVICE_CONTRACT_API_SUCCESS = buildApiTypeAction(UPDATE_SERVICE_CONTRACT, ApiActionTypes.SUCCESS)
export const UPDATE_SERVICE_CONTRACT_API_ERROR = buildApiTypeAction(UPDATE_SERVICE_CONTRACT, ApiActionTypes.ERROR)

const DELETE_SERVICE_CONTRACT_DEBIT = 'DELETE_SERVICE_CONTRACT_DEBIT';
export const DELETE_SERVICE_CONTRACT_DEBIT_API = buildApiTypeAction(DELETE_SERVICE_CONTRACT_DEBIT, ApiActionTypes.REQUEST)
export const DELETE_SERVICE_CONTRACT_DEBIT_API_SUCCESS = buildApiTypeAction(DELETE_SERVICE_CONTRACT_DEBIT, ApiActionTypes.SUCCESS)
export const DELETE_SERVICE_CONTRACT_DEBIT_API_ERROR = buildApiTypeAction(DELETE_SERVICE_CONTRACT_DEBIT, ApiActionTypes.ERROR)